import { useEffect, useState } from "react"
import * as React from "react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useReactToPrint } from "react-to-print"

import { canViewThisPage } from "@/lib/api/auth"
import { getConnectionStatusTableData } from "@/lib/api/billing"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { connectionStatus } from "@/components/table/columns/connection-status-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import AddConnectionStatusPage from "./add"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/connection-status/",
)({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_connectionstatus")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: ConnectionStatusPage,
})

function ConnectionStatusPage() {
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)
  const {
    data: connectionStatusDetails,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["connectionStatusDetails"],
    queryFn: () => getConnectionStatusTableData(),
  })

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return (
    <main className="space-y-4 p-4">
      <Header>Connection Status</Header>
      <div ref={contentRef} className="print:p-2">
        <DataTable
          columns={connectionStatus}
          data={connectionStatusDetails ?? []}
          search={{
            field: "status_name",
            label: "name",
          }}
          //tableTitle="Connection Status"
          isLoading={isLoading}
          isError={isError}
        >
          <div className="flex w-full justify-end">
            <AddConnectionStatusPage />
          </div>
          <Button className="mx-1" onClick={() => reactToPrintFn()}>
            <Icons.download />
            Print Connection Status
          </Button>
          <ExportOperationModal
            tableData={connectionStatusDetails ?? [{}]}
            fileName="Connection Status"
            showExportModal={showExportModal}
            setShowExportModal={setShowExportModal}
          />
        </DataTable>
      </div>
    </main>
  )
}
